import { createContext } from 'react';
import eventDispatcher from 'Utils/eventDispatcher';

export const EventDispatcherContext = createContext(eventDispatcher);
